import { useCallback,useEffect,useState } from 'react'
import { api,get } from '../lib/api'
import { enablePush,pushState,type PushState } from '../lib/push'
import { errorText,mt } from '../lib/i18n'
import { nativeAvailable } from './native'
import NativeNotifications from './NativeNotifications'

/** One switch for phone alerts. On means this device is signed up AND the person has not paused them. */
export function useAlerts(name?:string){
 const [push,setPush]=useState<PushState>('off'),[paused,setPaused]=useState(false),[devices,setDevices]=useState<number|null>(null),[busy,setBusy]=useState(false),[error,setError]=useState('')
 const load=useCallback(()=>{void pushState().then(setPush).catch(()=>{/* off */});void get<{pushOff:boolean;devices:number}>('/api/market/notify-prefs').then(r=>{setPaused(r.pushOff);setDevices(r.devices)}).catch(()=>{/* on */})},[])
 useEffect(()=>{load()},[load])
 // On means the server really has this phone, not just that the browser has a subscription.
 const on=!paused&&(nativeAvailable||(push==='on'&&(devices??0)>0))
 useEffect(()=>{if(!nativeAvailable&&push==='on'&&devices===0&&!paused)void enablePush(name).then(()=>load()).catch(()=>{/* the switch stays off and can be tapped */})},[push,devices,paused,name,load])
 const blocked=push==='blocked'&&!nativeAvailable,unsupported=push==='unsupported'&&!nativeAvailable
 const status=blocked?mt('acctNotifBlocked'):unsupported?mt('acctNotifBlocked'):on?mt('acctNotifOn'):mt('acctNotifOff')
 const set=(pushOff:boolean)=>api('/api/market/notify-prefs',{method:'POST',body:JSON.stringify({pushOff})})
 async function flip(next:boolean){
  setBusy(true);setError('')
  try{
   if(next){if(!nativeAvailable)await enablePush(name);await set(false)}
   else await set(true)
  }catch(e){setError(`${errorText(e)} (${(e as Error).message})`)}finally{load();setBusy(false)}
 }
 const [tested,setTested]=useState('')
 async function test(){setTested('');try{await api('/api/market/notify-test',{method:'POST'});setTested(mt('alertTestSent'))}catch(e){setError(errorText(e))}}
 return {on,status,busy,error,tested,test,disabled:busy||blocked||unsupported,flip}
}
/** A button, not a checkbox, so what you see can only ever be what the page knows. */
export function AlertsSwitch({alerts,label}:{alerts:ReturnType<typeof useAlerts>;label:string}){
 return <button type="button" role="switch" aria-checked={alerts.on} aria-label={label} className={`switch${alerts.on?' on':''}`} disabled={alerts.disabled} onClick={()=>void alerts.flip(!alerts.on)}><span/></button>
}
export {NativeNotifications}
